/**
 * StatusBadge Component
 * The OmniMind tag: a soft tinted pill with an optional state dot.
 */

import React from 'react';
import { cn } from '../../utils/cn';

type StatusType = 'active' | 'inactive' | 'error' | 'syncing' | 'pending' | 'success';

interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  customLabel?: string;
}

const config: Record<StatusType, { tag: string; label: string; animate: string }> = {
  active: { tag: 'tg-g', label: 'Live', animate: 'status-pulse' },
  success: { tag: 'tg-g', label: 'Success', animate: '' },
  syncing: { tag: 'tg-b', label: 'Syncing', animate: 'status-pulse' },
  error: { tag: 'tg-r', label: 'Error', animate: '' },
  inactive: { tag: 'tg-n', label: 'Inactive', animate: '' },
  pending: { tag: 'tg-a', label: 'Pending', animate: '' },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = 'md',
  showIcon = true,
  customLabel,
}) => {
  const current = config[status] || config.inactive;

  const sizeStyle: React.CSSProperties =
    size === 'lg'
      ? { fontSize: 12, padding: '4px 11px' }
      : size === 'sm'
      ? { fontSize: 10, padding: '2px 8px' }
      : {};

  return (
    <span className={cn('tg', current.tag)} style={sizeStyle}>
      {showIcon && <span className={cn('dotk', current.animate)} />}
      {customLabel || current.label}
    </span>
  );
};
